<template>
    <div>
        <div class="content-caption dashed bg-white">
            <span>卖家信息</span>
        </div>
        <div class="form-info">
            <div class="form-row">
                <div class="form-label">
                    <label>公司名称</label>
                </div>
                <div class="form-value">
                    <div class="value">{{tradeVoucher.sellerName}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>联系人</label>
                </div>
                <div class="form-value">
                    <div class="value">{{tradeVoucher.servicer.contactName}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>联系电话</label>
                </div>
                <div class="form-value">
                    <div class="value">{{tradeVoucher.servicer.contactTel}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>所在地址</label>
                </div>
                <div class="form-value">
                    <div class="value">{{tradeVoucher.servicer.servicerCom.regionName}}</div>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span><span class="color-laber"></span>买方信息</span>
        </div>

        <div class="form-info a">
            <div class="form-row">
                <div class="form-label">
                    <label>零售商名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <div class="value">{{tradeVoucher.buyerName}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>零售商联系方式</label>
                </div>
                <div class="form-value width-1-5x">
                    <div class="value">{{tradeVoucher.retailerCom.contactTel}}</div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>零售商地址</label>
                </div>
                <div class="form-value width-1-5x">
                    <div class="value">{{tradeVoucher.retailerCom.regionName}}</div>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span><span class="color-laber"></span>审核</span>
        </div>
        <div class="form-info a">
            <div class="examine-title">
                <span class="mr10">审核结果</span>
                <el-radio class="radio" v-model="auditStateValue" :label=auditState.value v-for="auditState in auditStateList">{{auditState.text}}</el-radio>
            </div>
        </div>
        <div class="examine-item">
            <div class="examine-content" style="padding-left: 0;">
                <div class="form-info">
                    <div class="form-row" style="line-height: 90px;">
                        <div class="form-label" style="width: auto">
                            <label class="font-bold">审核描述</label>
                        </div>
                        <div class="form-value">
                            <textarea class="width-2x" placeholder="审核描述" v-model="auditDesc"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import tradeApi from '../../api/trade'

    export default {
        name: 'swb-trade-voucher-check',
        desc: '交易单审核',
        props: ["id"],
        data: function () {
            return {
                tradeVoucher: {},
                auditStateList: [],
                auditStateValue: null,
                auditDesc: null
            }
        },
        created: function () {
            //
            let auditState = getEnumList("auditState");
            for(let i = 0; i < auditState.length; i++) {
                if(auditState[i].name === "Initial") {
                    auditState.splice(i, 1);
                    i--;
                }
                if(auditState[i].name === "AuditPass") {
                    auditState[i].text = "通过";
                    this.auditStateValue = auditState[i].value;
                }
                if(auditState[i].name === "AuditFail") {
                    auditState[i].text = "不通过";
                }
            }
            this.auditStateList = auditState;
            //
            this.getTradeVoucher();
        },
        methods: {
            // 交易单详情
            getTradeVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                tradeApi.getTradeVoucher(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        self.tradeVoucher = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let tradeVoucher = {};
                tradeVoucher.id = self.id;
                tradeVoucher.auditState = self.auditStateValue;
                tradeVoucher.auditDesc = self.auditDesc;
                result.data = tradeVoucher;
                result.type = "info";
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherCheck.vue